import { Component, OnInit, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'metric-circle',
  templateUrl: './metric-circle.component.html',
  styleUrls: ['./metric-circle.component.scss']
})
export class MetricCircleComponent implements OnInit {
  @ViewChild('circle') circleRef;
  @Input() color = '';
  @Input() inverted = false;
  @Input() metric: Number|string = '';
  @Input() name: string = '';
  @Input() percent = 0;

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.circleRef) {
        const circle = this.circleRef.nativeElement;
        const radius = circle.r.baseVal.value;
        const circumference = radius * 2 * Math.PI;

        circle.style.strokeDasharray = `${circumference} ${circumference}`;
        circle.style.strokeDashoffset = `${circumference}`;
        this.updatePercentComplete();
      }
    });
  }

  ngOnChanges() {
    if (this.percent * 100 > 0) {
      if (this.circleRef) {
        this.updatePercentComplete();
      }
    }
  }

  updatePercentComplete() {
    const circle = this.circleRef.nativeElement;
    const radius = circle.r.baseVal.value;
    const circumference = radius * 2 * Math.PI;
    const offset = circumference - Number(this.percent) * circumference;
    circle.style.strokeDashoffset = offset;
  }

  getRotation() {
    return this.inverted ? `rotate(${-90 + (360 - this.percent * 360)}deg)` : 'rotate(-90deg)';
  }
}
